const newHeaderPresenter = require('./headerPresenter');
const newResultsPresenter = require('./resultsPresenter');
const newModel = require('./model');
const { queryParser } = require('gui');
const customerCode = queryParser.get('id') || 'tim';

module.exports = function mainPresenter() {
    const view = require('./mainPresenter.tpl.html');
    var c = {};
    var model = newModel();
    var headerPresenter = newHeaderPresenter(model);
    var resultsPresenter = newResultsPresenter(model);

    c.activate = function(region) {
        region.classList.add(customerCode);
        view.activate(region);
        headerPresenter.activate(view.headerRegion);
        resultsPresenter.activate(view.resultsRegion);
    };

    return c;
};
